import { importProvidersFrom, makeEnvironmentProviders } from '@angular/core';
import { DataAccessApiModule } from '@core/api';
import { environment } from '@environments/environment';

export function provideAPIModule() {
  return makeEnvironmentProviders([importProvidersFrom(DataAccessApiModule.forRoot({ rootUrl: environment.apiUrl }))]);
}
